import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { ORGANIZATION_SETTINGS_ROUTE } from 'router/routes';
import { selectActiveOrganization } from 'redux/auth';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import LoadingState from 'components/LoadingState';
import ToastActions from 'redux/toast';
import { exists } from 'lib/types';
import { getDynamicRoute } from 'lib/frontend/utils/router';
import { logInfo, logWarn } from 'utils/logger';

export default function StripeConnect() {
  const activeOrganization = useAppSelector(selectActiveOrganization);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  /**
   * Assume arriving here means successful setup for now
   * Otherwise we will need to setup new routes and stripe queries to interrogate status
   */
  useEffect(() => {
    const handleReturnFromStripe = () => {
      const logData = {
        activeOrganization: activeOrganization?.id ?? 'undefined'
      };
      if (!exists(activeOrganization)) {
        logWarn(
          '[StripeConnect] No active organization found. Returning.',
          logData
        );
        return;
      }

      logInfo(
        '[StripeConnect] Returned from Stripe onboarding. Redirecting...',
        logData
      );

      dispatch(
        ToastActions.toastSuccess({
          headerText: 'Stripe onboarding complete',
          bodyText:
            'All payouts to this publication will be sent to the linked account.'
        })
      );

      navigate(
        getDynamicRoute(
          ORGANIZATION_SETTINGS_ROUTE,
          {},
          {
            tab: 'payment-settings'
          }
        )
      );
    };

    handleReturnFromStripe();
  }, [activeOrganization?.id, dispatch, navigate]);
  return <LoadingState />;
}
